var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"space-y-4"},_vm._l((_vm.approvalRequests),function(approvalRequest){return _c('li',{key:approvalRequest.id},[_c('ApprovalRequestListItem',{attrs:{"approval-request":approvalRequest}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }